import React, { lazy, Suspense } from 'react';
import './index.css';

// Critical layout components - load immediately
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Footer from "./components/Footer/Footer";

// Lazy load only below-the-fold sections
const OurTutors = lazy(() => import("./components/OurTutors/OurTutors"));
const Courses = lazy(() => import("./components/Courses/Courses"));
const AboutUs = lazy(() => import("./components/AboutUs/AboutUs"));
const FAQ = lazy(() => import("./components/FAQ/FAQ"));
const ContactForm = lazy(() => import("./components/AboutUs/Contact"));

// Simple loading fallback
const LoadingSpinner = () => (
  <div className="flex items-center justify-center py-20">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
);

const App = () => {
  return (
    <div className="overflow-x-hidden bg-white text-dark">
      <main>
        {/* Critical components - render immediately */}
        <Navbar />
        <section id="hero">
          <Hero />
        </section>
        
        {/* Below-the-fold sections - single Suspense wrapper */}
        <Suspense fallback={<LoadingSpinner />}>
          <section id="our-tutors">
            <OurTutors />
          </section>
          
          <section id="services">
            <Courses />
          </section>

          <section id="about-us">
            <AboutUs />
          </section>

          <section id="faq">
            <FAQ />
          </section>
          
          <section id="contact-us">
            <ContactForm />
          </section>
        </Suspense>
        
        {/* Critical footer - render immediately */}
        <Footer />
      </main>
    </div>
  );
};

export default App;
